import React from 'react';
import { Search, Trash2 } from 'lucide-react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import ColumnToggle from './ColumnToggle';

/**
 * TableToolbar — Search, stage filter, bulk actions, column toggle.
 * Mobile: full-width search + inline stage select, 44px touch targets.
 * Desktop: original compact layout with column toggle visible.
 */
const TableToolbar = ({
  searchTerm,
  onSearchChange,
  selectedCount,
  onBulkDelete,
  visibleColumns,
  onColumnToggle,
  stageFilter,
  onStageFilterChange,
  availableStages,
}) => {
  return (
    <div className="bg-white border-b border-gray-200 p-3 lg:p-4">
      <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between lg:gap-4">
        {/* Search + stage filter */}
        <div className="flex items-center gap-2 flex-1">
          {/* Search — full width on mobile */}
          <div className="relative flex-1 lg:max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              type="text"
              placeholder="Search clients..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 h-11 lg:h-9 text-sm w-full"
              data-testid="clients-search-input"
            />
          </div>
          {/* Stage filter — always visible, touch-friendly on mobile */}
          <select
            value={stageFilter}
            onChange={(e) => onStageFilterChange(e.target.value)}
            className="h-11 lg:h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 flex-shrink-0 bg-white"
            data-testid="clients-stage-filter"
          >
            <option value="">All Stages</option>
            {availableStages.map((stage) => (
              <option key={stage} value={stage}>{stage}</option>
            ))}
          </select>
        </div>

        {/* Bulk delete + column toggle — desktop only */}
        <div className="hidden lg:flex items-center gap-2">
          {selectedCount > 0 && (
            <Button
              variant="outline"
              size="sm"
              onClick={onBulkDelete}
              className="text-red-600 border-red-300 hover:bg-red-50"
              data-testid="bulk-delete-btn"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Delete ({selectedCount})
            </Button>
          )}
          <ColumnToggle
            visibleColumns={visibleColumns}
            onToggle={onColumnToggle}
          />
        </div>
      </div>
    </div>
  );
};

export default TableToolbar;
